var map = {
	"./ay.png": "XE7c",
	"./bg.png": "yRcn",
	"./call.png": "6YKS",
	"./en.png": "hRk0",
	"./es.png": "nJ7a",
	"./fb.png": "bOdt",
	"./mail.png": "8ni1",
	"./no-preview.png": "ROEO",
	"./tw.png": "oLZb",
	"./whatsapp.png": "RdO0",
	"./wp.png": "V4lv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 1